module.exports = __webpack_public_path__ + "static/media/11.cab6a6a5.JPG";